// Dev-only logger. Strips console output in production builds.
// The console.* calls below are INTENTIONALLY gated by NODE_ENV — this file is
// the env-based wrapper itself, so disable no-console for these three lines.
const isDev = process.env.NODE_ENV !== "production";

/* eslint-disable no-console */
export const logger = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
/* eslint-enable no-console */
